import styled, {css} from "styled-components";
import {FlexboxGrid} from "rsuite";

export const Grid = styled(FlexboxGrid)`
    
    ${props => !props.noGutters && css`
        margin-bottom: -15px;
        margin-left: -6px;
        margin-right: -6px;
    `}
    
    ${props => props.noWrap && css`
        && {
            flex-wrap: nowrap;
        }
    `}
`;

export const GridItem = styled(FlexboxGrid.Item)`
    padding-bottom: 15px;
    
    ${props => props.isFullWidth && css`
        width: 100%;
    `}
    
    ${props => !props.noGutters && css`
        padding-left: 6px;
        padding-right: 6px;
    `}
    
    && {
        flex-shrink: 1;
    }
    
    .rs-form-group {
        margin: 0;
    }
    
    &:last-child {
        margin-right: 0;
    }
`;